<template>
  <main>
    <b-row>
      <b-col cols="6" offset="3" class="pt-4 mt-4"> 
        <div class="login-box">
          <a class="logo"><img src="/images/logo-mynd.svg" alt="Mynd - Context Mining" /></a>
          <h2 class="tagline" v-if="company !== 'na'">For <span>{{ company }}</span> <b-button variant="outline" color="creax" size="sm" @click="changeRealm()"><i class="fa fa-eraser" /></b-button></h2>
          <h2 class="tagline" v-else>&nbsp;</h2>
          <b-form @submit.prevent="submit">
            <b-form-group
              id="fieldset-1"
              description=""
              label="Enter your Email"
              label-for="input-1"
            >
              <b-form-input type="text" id="input-1" v-model="form.email" trim></b-form-input>
            </b-form-group>
            <b-form-group
              id="fieldset-2"
              description=""
              label="Enter your password"
              label-for="input-2"
            >
              <b-form-input type="password" id="input-2" v-model="form.password" trim></b-form-input>
            </b-form-group>
            <b-card no-body class="card card-login p-4"
              v-if="showForceOption"
            >
              <b-form-checkbox id="confirm" v-model="form.forceLogin" name="force_login" value="yes" unchecked-value="no">
                Force Login! I accept and understand that i may loose unsaved data.
              </b-form-checkbox>
            </b-card>
            <div v-if="multiRealms" class="realms">
              <h2 class="tagline">Please select company</h2>
              <b-card no-body class="card card-company p-4"
                v-for="realm in multiRealms" :key="realm._id"
              >
                <b-form-checkbox :id="realm._id" v-model="company" name="force_login" :value="realm.company" :unchecked-value="null">
                  {{ realm.company }}
                </b-form-checkbox>
              </b-card>
            </div>
            <div class="d-flex mt-4">
              <b-button type="submit" variant="primary">Submit</b-button>
              <router-link :to="{ name: 'Forgot' }" class="sidelink">Forgot Password?</router-link>
              <!--<b-button @click="forgotPass()" class="sidelink">Forgot Password?</b-button>-->
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </main>
</template>

<script>
import axios from "axios";
import { mapMutations, mapActions } from 'vuex';
import {
  SAVE_LOADING_STEP,
  TOGGLE_LOADING
} from "@/store/mutation-types";
export default {
  name: 'Login',
  data() {
    return {
      form: {
        email: '',
        password: '',
        forceLogin: 'no'
      },
      company: 'na',
      showForceOption: false,
      multiRealms: null
    };
  },
  mounted() {
    this.checkAppDeployVersion();
    this.company = localStorage.getItem('company') || 'na';
    this.SAVE_LOADING_STEP({ loading_step: "" });
    this.TOGGLE_LOADING({ loading: false });
  },
  methods: {
    ...mapActions(['saveAuthenticatedUserInfo', 'savePasswordStatus']),
    ...mapMutations([SAVE_LOADING_STEP, TOGGLE_LOADING]),
    async submit() {
      const User = new FormData();
      User.append('email', this.form.email);
      User.append('password', this.form.password);
      User.append('myrealm', this.company);
      User.append('forcelogin', this.form.forceLogin);
      const headers = {};
      return axios
        .post(`/auth`, User, {
          headers
        })
        .then(response => {
          console.log(response, response.data);
          localStorage.setItem("auth_provider", "fastapi");
          localStorage.setItem("jwt", response.data.token);
          localStorage.setItem("company", response.data.company);
          localStorage.setItem("username", response.data.username);
          localStorage.setItem("passupdated", response.data.pUpdated);
          this.savePasswordStatus(response.data.pUpdated);
          this.saveAuthenticatedUserInfo({"username": response.data.username});    
          window.location.href = "/";
          //this.$router.push("/projects").catch(()=>{});
        })
        .catch((error) => {
          console.log(error.response);
          if(error.response.data.detail === 'User Already Logged in'){
            this.showForceOption = true;
          }
          if(error.response.status === 420){
            this.multiRealms = error.response.data.detail.data;
            this.$toasted.show(error.response.data.detail.message, {
              type: "error",
            });
          }
          if(Array.isArray(error.response.data.detail)){
            this.$toasted.show(error.response.data.detail[0].msg, {
              type: "error",
            });
          }
          else{
            this.$toasted.show(error.response.data.detail, {
              type: "error",
            });
          }
        });
    },
    confirmAppDeployVersionAndReload(deployDate) {
      this.$bvModal.msgBoxOk(
        "The application has been updated to a new version. Click OK to continue.",
        {
          title: "Application Updated",
          size: "md",
          okVariant: "primary",
          okTitle: "OK",
          hideHeaderClose: false,
          centered: true
        }
      ).then(() => {
          // User clicked OK
          localStorage.setItem("appDeployDate", deployDate);
          window.location.replace(
          window.location.origin + window.location.pathname + '?v=' + new Date().getTime());
        }
      );
    },
    checkAppDeployVersion() {
      const CURRENT_DEPLOY_DATE = process.env.VUE_APP_DEPLOY_AT;
      const STORED_DEPLOY_DATE = localStorage.getItem("appDeployDate");
      /* Executed only on first deployment */
      if (STORED_DEPLOY_DATE === null) {
        this.confirmAppDeployVersionAndReload(CURRENT_DEPLOY_DATE);
        return false;
        
      }
      if (STORED_DEPLOY_DATE !== CURRENT_DEPLOY_DATE) {
          this.confirmAppDeployVersionAndReload(CURRENT_DEPLOY_DATE);
          return false;
      }
      const url = new URL(window.location.href);
      if (url.searchParams.has("v")) {
        url.searchParams.delete("v");
        window.history.replaceState({}, document.title, url.pathname); 
      }
      return true;
    },
    changeRealm(){
      this.company = 'na';
      localStorage.setItem('company', this.company);
      this.multiRealms = null;
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }
}
</script>